module.exports = __webpack_public_path__ + "static/media/riskyActivityCheck.197ad71c.mp3";